import { Component } from '@angular/core';
import { NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { translation } from './language/translate';
import { LanguageService } from './modules/core/service/language.service';
import { AsideAction } from './modules/core/store/aside.action';
import { DialogAction } from './modules/core/store/dialog.action';
import { ErrorsAction } from './modules/core/store/errors.state';
import { RouterAction } from './modules/core/store/router.action';
import { UserAction } from './modules/core/store/user.action';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {

    subscriptions: Subscription[] = [];

    constructor(private translateService: TranslateService,
                private languageService: LanguageService,
                private router: Router,
                private store: Store,
    ) {
        Object.keys(translation).forEach(key => {
            this.translateService.setTranslation(key, translation[key]);
        });
        this.translateService.setDefaultLang(languageService.getCurrent());
        this.translateService.use(languageService.getCurrent());
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.router.events.subscribe((evt) => {
                if (evt instanceof NavigationError) {
                    this.store.dispatch([
                        new RouterAction.Navigate(['/main']),
                        new DialogAction.OpenFailedRouting(evt.url),
                    ]);
                    return;
                } else if (evt instanceof NavigationStart) {
                    this.store.dispatch(new UserAction.SetURL(evt.url));
                    return
                } else if (evt instanceof NavigationEnd) {
                    document.getElementsByClassName('page-content')[0].scrollTop = 0;
                    this.store.dispatch(new AsideAction.CloseAll());
                    this.store.dispatch(new ErrorsAction.CleanMain());
                }
            })
        );
    }

}
